import React from 'react'
import styled from 'styled-components'
import { Button, Space, Card } from 'antd'

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  padding: 12px;

  @media (min-width: 768px) {
    justify-content: space-between;
  }
`

const FilterSection = styled.div`
  flex: 1;
  min-width: 100%;
  padding: 12px;

  @media (min-width: 768px) {
    min-width: ${props => (props.$isMiddleSection ? '100%' : 'calc(50% - 8px)')};
    order: ${props => (props.$isMiddleSection ? 2 : 'initial')};
  }

  @media (min-width: 1200px) {
    min-width: ${props => (props.$isMiddleSection ? 'calc(50% - 16px)' : 'calc(25% - 12px)')};
    order: initial;
  }
`

const CardSection = styled(Card)`
  flex: 1;
  min-width: 100%;

  .ant-card-head {
    min-height: 40px;
    padding: 0 12px;

    .ant-card-head-title {
      padding: 8px 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .ant-card-body {
    padding: 12px;
  }

  @media (min-width: 768px) {
    min-width: calc(50% - 8px);
  }

  @media (min-width: 1200px) {
    min-width: calc(25% - 12px);
  }
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
`

const PeriodText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
`

const ResponseCount = styled.span`
  color: #8c8c8c;
  font-size: 12px;
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const StyledButton = styled(Button)`
  &.ant-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 28px;
    padding: 4px 8px;
    font-size: 13px;

    &.selected {
      background-color: #00b3b0;
      color: white;
    }
  }
`

const CheckIcon = () => <span style={{ color: 'inherit', fontSize: '12px' }}>✓</span>

const RightButtonsContainer = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);

  .full-width {
    grid-column: 1 / -1;
  }
`

const MiddleContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 16px;
`

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const CenterColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
`

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 240px;
`

const TopBottomContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`

const BottomButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`

const Filters = () => {
  return (
    <FiltersContainer>
      {/* Left Section - Period Filter with Card */}
      <CardSection
        title={
          <Space>
            Talent Retention
            <ResponseCount>2 / 60 Responses</ResponseCount>
          </Space>
        }
      >
        <PeriodText>Period: 17/07/24 - 14/08/24</PeriodText>
      </CardSection>

      {/* Middle Section - Data Filter */}
      <FilterSection $isMiddleSection>
        <MiddleContainer>
          <LeftColumn>
            <StyledButton className="selected">Dimensions</StyledButton>
            <StyledButton>Items</StyledButton>
          </LeftColumn>

          <CenterColumn>
            <StyledButton className="selected">
              <CheckIcon /> Apoyo
            </StyledButton>
            <StyledButton className="selected">
              <CheckIcon /> Recursos
            </StyledButton>
            <StyledButton className="selected">
              <CheckIcon /> Recomendación
            </StyledButton>
            <StyledButton className="selected">
              <CheckIcon /> Puesto
            </StyledButton>
            <StyledButton className="selected">
              <CheckIcon /> Satisfacción
            </StyledButton>
            <StyledButton className="selected">
              <CheckIcon /> Engagement
            </StyledButton>
            <StyledButton>Equidad</StyledButton>
            <StyledButton>Permanencia</StyledButton>
          </CenterColumn>

          <RightColumn>
            <TopBottomContainer>
              <StyledButton className="selected">Top 5</StyledButton>
              <StyledButton>Bottom 5</StyledButton>
            </TopBottomContainer>
            <StyledButton>My priorities</StyledButton>
            <StyledButton>Company Overall</StyledButton>
          </RightColumn>
        </MiddleContainer>
      </FilterSection>

      {/* Right Section - Breakouts Filter */}
      <FilterSection>
        <RightButtonsContainer>
          <StyledButton className="selected">Favorability</StyledButton>
          <StyledButton>Score</StyledButton>
          <StyledButton className="full-width">Breakouts</StyledButton>
          <StyledButton className="full-width">Benchmark</StyledButton>
        </RightButtonsContainer>
      </FilterSection>
    </FiltersContainer>
  )
}

export default Filters
